import Vue from 'vue'
import TreeItem from '@/components/tree/Tree-item.vue'

Vue.component('tree-item', TreeItem)

export default {
    name: 'Tree',
    data () {
        return {
            bus: new Vue(),
        }
    },
    created() {
        this.bus.$on('select', model => {
            this.$emit('select', model);
        })

        this.bus.$on('update', () => {
            Vue.nextTick(() => {
                this.$emit('update');
            })
        })
    },
    props: {
        data: {
            type: Array,
            required: true
        },
        root: {
            type: [Number, String],
            default: null,
        },
        value: {
            type: [Number, String],
            default: null,
        },
        search: {
            type: String,
            default: '',
        },
        /**
         * для выклчения иерархии, но сейчас не используется
         */
        notHierarchy: {
            type: Boolean,
            default: false
        },
        selectOnName: {
            type: Boolean,
            default: false
        },
        /**
         * открытые по умолчанию деревья,
         * если false то см. компонент tree-item
         */
        openDefault: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        tree() {
            let tree = []
            this.data.forEach(item => {
                let sorted = _.sortBy(item.children, map => {
                    return map.parent
                }).map(m => {
                    return { ...m, root: item.value, children: [] }
                })
                let treeList = []
                let lookup = {}
                sorted.forEach(obj => {
                    if (!this.notHierarchy) {
                        if (lookup[obj.value] === undefined) {
                            lookup[obj.value] = obj
                        }
                    } else {
                        tree.push(obj)
                    }
                })
                
                if (!this.notHierarchy) {
                    sorted.forEach(obj => {
                        if (obj.parent !== 0) {
                            lookup[obj.parent].children.push(obj)
                        } else {
                            treeList.push(obj)
                        }
                    })
                    tree.push({
                        ...item,
                        children: treeList,
                        value: null,
                        root: item.value,
                    })
                }
                
            })
            return tree
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/tree/tree.js